/*eslint @typescript-eslint/no-empty-function: "off"*/
import React from 'react';
import { IProviderItemViewWithData } from '../providers/providerTypes';

export interface IOpenItemsContext {
  openItems: number[];
  changeOpenItems: (itemId: number, providerId: number) => void;
  handleOpenItem: (
    item: IProviderItemViewWithData,
    status: string,
    closeCurrent?: boolean,
    isNewTab?: boolean,
    params?: { [key: string]: string }
  ) => void;
  handleMinimizeAllItems: () => void;
}

export const OpenItemsContext = React.createContext<IOpenItemsContext>({
  openItems: [],
  changeOpenItems: () => {},
  handleOpenItem: () => {},
  handleMinimizeAllItems: () => {},
});

export const withOpenItemsContext =
  (Component: React.ComponentType<any>) => (props: any) => (
    <OpenItemsContext.Consumer>
      {(OpenItemsContext: IOpenItemsContext) => (
        <Component {...props} openItemsContext={OpenItemsContext} />
      )}
    </OpenItemsContext.Consumer>
  );
